import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import '@fontsource/abel';
import '@fontsource/source-code-pro';
import './i18n';

// Suppress PayPal postMessage errors globally
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('postrobot')) {
    event.preventDefault();
    return false;
  }
});

// Suppress unhandled promise rejections from PayPal
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('postrobot')) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
